export enum BorderColor {
    BLACK = 'BLACK',
    GRAY = 'GRAY',
}
